import NavBar from 'components/NavBar';
import SideBar from 'components/SideBar';
import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import Home from 'components/Home';
import NoPage from 'components/NoPage';
import { ProtectedRoute } from 'core/route.protected';
import { PublicRoute } from 'core/route.public';
import Loading from 'components/_common/Loading';

import Dashboard from 'components/dashboard/Dashboard';
import Admin from 'components/admin/Admin';
import Reception from 'components/reception/Reception';
import TripFee from 'components/trip-fee/TripFee';
import Product from 'components/product/Product';
import Inbound from 'components/inbound/Inbound';
import Repair from 'components/repair/Repair';
import OutBound from 'components/outbound/OutBound';
import Trip from 'components/trip/Trip';
import Estimate from 'components/estimate/Estimate';
import AsAnalytics from 'components/as-analytics/AsAnalytics';
import Stock from 'components/stock/Stock';
import TodayReception from 'components/today-reception/TodayReception';
import AsCalendar from 'components/as-calendar/AsCalendar';
import Exchange from 'components/exchange/exchange';
import AgentStats from 'components/agent-stats/AgentStats';
import RepairStatistics from 'components/repair-statistics/RepairStatistics';

const Login = lazy(() => {
    return Promise.all([import(/* webpackChunkName: "LoginComponent" */ './components/login/Login'), new Promise((resolve) => setTimeout(resolve, 1000))]).then(([moduleExports]) => moduleExports);
});

class Layout extends React.Component {
    constructor(props: any) {
        super(props);

        for (let i = 0; i < document.body.classList.length; i++) {
            document.body.classList.remove(document.body.classList[0]);
        }
        document.body.style.minHeight = null;

        document.body.classList.add('sidebar-mini');
        document.body.classList.add('layout-fixed');
        document.body.classList.add('layout-navbar-fixed');
    }

    public render() {
        return (
            <div className="wrapper wrapper-list">
                <NavBar />

                <SideBar />

                <div className="content-wrapper px-4 py-2">
                    <Routes>
                        {/* <Route path='/' element={<Home />}></Route> */}

                        <Route path="/" element={<Dashboard />}></Route>

                        <Route
                            path="/login"
                            element={
                                <PublicRoute>
                                    <React.Suspense fallback={<Loading />}>
                                        <Login />
                                    </React.Suspense>
                                </PublicRoute>
                            }
                        ></Route>

                        <Route path="/admin/*" element={<Admin />}></Route>
                        <Route path="/reception/*" element={<Reception />}></Route>
                        <Route path="/today-reception/*" element={<TodayReception />}></Route>
                        <Route path="/inbound/*" element={<Inbound />}></Route>
                        <Route path="/repair/*" element={<Repair />}></Route>
                        <Route path="/outbound/*" element={<OutBound />}></Route>
                        <Route path="/trip/*" element={<Trip />}></Route>
                        <Route path="/estimate/*" element={<Estimate />}></Route>
                        <Route path="/product/*" element={<Product />}></Route>
                        <Route path="/trip-fee/*" element={<TripFee />}></Route>
                        <Route path="/stock/*" element={<Stock />}></Route>
                        <Route path="/as-analytics/*" element={<AsAnalytics />}></Route>
                        <Route path="/agent-stats/*" element={<AgentStats />}></Route>
                        <Route path="/repair-statistics/*" element={<RepairStatistics />}></Route>
                        <Route path="/as-calendar/*" element={<AsCalendar />}></Route>
                        <Route path="/exchange/*" element={<Exchange />}></Route>
                        <Route path="*" element={<NoPage />}></Route>
                    </Routes>
                </div>
            </div>
        );
    }
}

export default Layout;
